// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
import MiniCommonIcons from './MiniCommonIcons';

export type MiniCommonIconsSubset = { [icon in MiniCommonIcons]: string };

export let MiniCommonIconsDefinitions: MiniCommonIconsSubset = {
    Accept: '\ue8fb',
    AccessLogo: '\ued69',
    Add: '\ue710',
    Archive: '\uf03f',
    Attach: '\ue723',
    Back: '\ue72b',
    Blocked: '\ue733',
    Calendar: '\ue787',
    Cancel: '\ue711',
    Checkbox: '\ue739',
    CheckboxComposite: '\ue73a',
    CheckMark: '\ue73e',
    ChevronDown: '\ue70d',
    ChevronLeft: '\ue76b',
    ChevronRight: '\ue76c',
    ChevronUp: '\ue70e',
    CircleAdditionSolid: '\uf2e4',
    CircleFill: '\uea3b',
    CircleRing: '\uea3a',
    CityNext: '\uec06',
    Clock: '\ue917',
    Cloud: '\ue753',
    CompletedSolid: '\uec61',
    Contact: '\ue77b',
    Delete: '\ue74d',
    Download: '\ue896',
    Edit: '\ue70f',
    Encryption: '\uf69d',
    Error: '\ue783',
    Event: '\ueca3',
    EventAccepted: '\uf422',
    EventDateMissed12: '\uf764',
    EventDeclined: '\uf425',
    EventTentative: '\uf423',
    ExcelDocument: '\uef73',
    FabricFolder: '\uf0a9',
    FavoriteStar: '\ue734',
    FavoriteStarFill: '\ue735',
    FileImage: '\uf311',
    Forward: '\ue72a',
    GlobalNavButton: '\ue700',
    Help: '\ue897',
    Inbox: '\uf41c',
    Info: '\ue946',
    LyncLogo: '\ued79',
    Mail: '\ue715',
    OfficeLogo: '\ueb6e',
    OneNoteLogo: '\uf1e7',
    OpenInNewWindow: '\ue8a7',
    OutlookLogo: '\uf1e9',
    Page: '\ue7c3',
    PDF: '\uea90',
    People: '\ue716',
    Photo2Remove: '\uecac',
    POI: '\uecaf',
    PowerPointDocument: '\uef72',
    ProtectedDocument: '\ue8a6',
    PublisherLogo: '\uf1ed',
    RadioBtnOff: '\uecca',
    RadioBtnOn: '\ueccb',
    RecurringEvent: '\uef5d',
    Refresh: '\ue72c',
    RemoveEvent: '\ued8a',
    Room: '\ued9f',
    Save: '\ue74e',
    Search: '\ue721',
    Send: '\ue724',
    Settings: '\ue713',
    StatusErrorFull: '\ueb90',
    TextDocument: '\uf029',
    ToDoLogoOutline: '\uf75b',
    UnknownSolid: '\uf2e1',
    Video: '\ue714',
    VisioDocument: '\uf2a9',
    WordDocument: '\uef71',
    ZipFolder: '\uf012',
};

export default {
    fontFileName: 'miniCommonIcons',
    icons: MiniCommonIconsDefinitions,
};
